const TAIL_CHARS_BEFORE_EXTENSION = 4;

export const splitFileNameForMiddleTruncation = (fileName: string) => {
  const extensionStart = fileName.lastIndexOf('.');
  if (extensionStart < 1) {
    return { head: fileName, tail: '' };
  }

  const tailStart = extensionStart - TAIL_CHARS_BEFORE_EXTENSION;
  if (tailStart < 1) {
    return { head: '', tail: fileName };
  }

  return { head: fileName.slice(0, tailStart), tail: fileName.slice(tailStart) };
};
